import type { IconButtonProps } from '@src/shared/ui/Button';
import { DoubleArrowRightIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import NavIconButton from './NavIconButton';

const ForwardIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    return (
      <NavIconButton ref={ref} {...props}>
        <DoubleArrowRightIcon />
      </NavIconButton>
    );
  },
);

export default ForwardIconButton;
